<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/order/details/', projectId, orderId]">Zum Auftrag</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!positions">
  <h2>Transportschein {{ projectId }}.0005.{{ transportId }}</h2>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Transportschein vom: {{ transport[0].delivery_date | date:'dd.MM.yyyy'  }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}
      <clr-dropdown [clrCloseMenuOnItemClick]="true">
        <button clrDropdownTrigger aria-label="Dropdown demo button">
            <cds-icon shape="angle" direction="down"></cds-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen>
            <label class="dropdown-header" aria-hidden="true">Status ändern</label>
            <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
            <div clrDropdownItem *ngFor="let item of statusButtons let i = index" (click)="changeTransportStatus(transportId, i)">{{ item.display }}</div>
      </clr-dropdown-menu>
    </clr-dropdown>
  </span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row" *ngIf="!loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          {{ transport[0].name_project }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Empfänger
                    </div>
                    <div class="clr-col-9">
                      {{ transport[0].company_name }}<br />{{ transport[0].street }}<br />{{ transport[0].postcode }} {{ transport[0].city }}
                      <span *ngIf="transport[0].country !== 'Deutschland'">{{ transport[0].country }}</span>
                    </div>
                  </div>
                  <div *ngIf="!!person[0]" class="clr-row">
                    <div class="clr-col-3">
                      Ansprechpartner
                    </div>
                    <div class="clr-col-8">
                      {{ person[0].salutation }} {{ person[0].lastname }}
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/person/details', person[0].pid ]"></cds-icon>
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      gemäß Auftragsbestätigungsnummer
                    </div>
                    <div class="clr-col-8">
                      {{ transport[0].order_confirmation_id }}
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/order/details/', projectId, orderId]"></cds-icon>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/transport/update', projectId, jobId, transportId, orderId]">Transportschein bearbeiten</button>
                    <button class="btn btn-warning" (click)="deleteTransport(projectId, transportId)">Transportschein löschen</button>
                  </div>

                  <clr-datagrid *ngIf="editPos < 2" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-dg-action-bar *ngIf="((editPos < 2) && (statusText === 'In Arbeit'))">
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-warning-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Positionen löschen</button>
                      </div>
                    </clr-dg-action-bar>
                    <clr-dg-column [clrDgField]="'project_id'">Position</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column>Kennzeichnung</clr-dg-column>
                    <clr-dg-column>Spezifikation/Bemerkungen/Liefertext</clr-dg-column>
                    <clr-dg-column>Anzahl</clr-dg-column>
                    <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Transport Document {{ projectId }}.{{ transportId }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                      <clr-dg-cell>{{ position.position_label || position.position }}<span *ngIf="(position.part ?? 0) > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing ]">{{ position.technical_drawing }}</clr-dg-cell>
                      <clr-dg-cell>{{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span></clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification"><b>Spezifikation:</b> {{ position.specification }}<br /><br /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Lieferant):</b> {{ position.side_agreements }}<br /><br /></span>
                        <span *ngIf="position.remarks"><b>Liefertext:</b> {{ position.remarks }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell class="center">{{ position.number_of_pieces }}</clr-dg-cell>
                      <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                        <button class="btn btn-sm" (click)="updatePositionMode(i, position.position ?? 0, position.part ?? 0)">
                          <cds-icon shape="pencil"></cds-icon>
                          <span class="clr-icon-title">Ändern</span>
                        </button>
                      </clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-order-transport-edit-positions [projectId]="projectId" [transportId]="transportId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2"  (updatedPosition)="updateTransport($event)"></app-order-transport-edit-positions>

                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="openPdfPreview()">PDF anzeigen</button>
                    <button *ngIf="editPos === 0" class="btn" (click)="editPos = 1;">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                  </div>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ transport[0].employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">Transportschein {{ projectId }}.0005.{{ transportId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>


<!--<pre class="datepicker-output">
    {{ person | json }}
</pre>

<pre class="datepicker-output">
    {{ transport | json }}
</pre>-->
